// storage
import { storage } from '@goldblack/client-storage';
import { def } from '@goldblack/shared';

// client-shared
import { log } from '@goldblack/client-utils';

// `config` is null when the cached copy is current (same hash), so keep the localStorage one.
function saveConfig(config) {
    if (!config) return;
    storage.transience.setState('config', config.data);
    storage.localStorage.setState('config', config);
}

function authencated(data) {
    const { user, config, legal, setting } = data;

    storage.transience.setState({
        user,
        'path.gateway': 'main',
        'main.notice': legal ?? [],
        setting: setting ?? {},
    });
    saveConfig(config);
}

// Logged-out visitor: open the app with public screens only.
function browseAsGuest(config) {
    storage.transience.setState({ user: null, 'path.gateway': 'main' });
    saveConfig(config);
}

function handleResponse(res) {
    let code = res.data.code;
    let message = res.data.message;

    switch (code) {
        case def.ErrorCode.AUTH_UNAUTHORIZED:
            storage.transience.setState('path.gateway', 'login');
            break;
        case def.ErrorCode.AUTH_BANNED_USER:
            storage.transience.setState('internal.error', 'blocked user');
            break;
        default:
            break;
    }

    if (message) {
        if (import.meta.env.MODE === 'production') {
            message = `Error ${code}`;
        }
        storage.transience.setState('internal.error', message);
    }
}

function handleError(err) {
    if (err.response) {
        let message = '';
        switch (err.response.status) {
            case def.StatusCodes.FORBIDDEN:
                message = 'You do not have permission to perform this action.';
                break;
            case def.StatusCodes.INTERNAL_SERVER_ERROR:
                message = 'Something went wrong while processing your request. Please try again in a moment.';
                break;
            case def.StatusCodes.NOT_IMPLEMENTED:
                message = 'This feature isn’t available yet. It will be supported in a future update.';
                break;
            case def.StatusCodes.BAD_GATEWAY:
                message = 'There was a problem connecting to the server. Please try again soon.';
                break;
            case def.StatusCodes.SERVICE_UNAVAILABLE:
                message = 'The server is temporarily unavailable. Please try again in a moment.';
                break;
            case def.StatusCodes.GATEWAY_TIMEOUT:
                message = 'The server is taking longer than expected to respond. Please try again later.';
                break;
            default:
                message = 'An unexpected error occurred. Please try again.';
                break;
        }

        if (message) {
            storage.transience.setState('internal.error', message);

            if (import.meta.env.MODE === 'development') {
                log.consoleError(`status:${err.response.status} data:${JSON.stringify(err.response.data)}`);
            }
        }
    }
}

export { authencated, browseAsGuest, saveConfig, handleResponse, handleError };
